import React from 'react'

const Manual_cliente_natural_gt = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Creación de un Cliente Natural | Guatemala
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Este proceso permite registrar un cliente natural en el sistema al momento de generar una orden en Guatemala. Es importante completar correctamente los datos básicos del cliente para asegurar que la factura electrónica se emita de forma válida.
        </p>
        <iframe
          src="https://scribehow.com/embed/Creacion_de_un_Cliente_Natural_en_Guatemala___wMFNYzJ4T5ia-gwpuNCFqg?as=scrollable"
          className="scribe-iframe-general-61"
          width="100%"
          height="6000"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_cliente_natural_gt
